/* eslint no-unused-vars: "off" */
/* eslint import/no-unresolved: "off" */
import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { AnalyticsProvider } from '@carvana/eventable-clickstream';
import ThemeProvider, { createGlobalStyle } from '@carvana/showroom-theme';
import { ConnectedRouter } from 'connected-react-router';
import { MfeConfig } from '@carvana/microfrontend';
import Routes from './Routes';
import store, { history } from './store/configureStore';
import { Analytics } from './constants';
import ScrollToTop from './components/future-packages/scroll-to-top';
import './styles/global.css';
import '@carvana/header/styles.css';
import { config } from './microfrontend.config';
import initDataDog from './utils/datadog-init';

declare global {
  namespace NodeJS {
    interface ProcessEnv {
      NODE_ENV: 'development' | 'test' | 'uat' | 'production';
    }
  }
}

//  createGlobalStyle method takes -- 'development' | 'test' | 'uat' | 'production' | 'prod' -- as env's
const GlobalStyles = createGlobalStyle(process.env.NODE_ENV, null as any);
//  AnalyticsProvider.environment (below) takes -- 'dev' | 'test' | 'uat' | 'production' -- as env's
const environment =
  process.env.NODE_ENV === 'development' ? 'dev' : process.env.NODE_ENV;

if (process.env.LOCAL !== 'true') {
  initDataDog();
}

export default function App() {
  useEffect(() => {
    MfeConfig(config);
  }, []);

  return (
    <AnalyticsProvider
      environment={environment}
      projectName={Analytics.PROJECT_NAME}
      track={Analytics.TEAM_NAME}
    >
      <Provider store={store as any}>
        <ThemeProvider>
          <GlobalStyles />
          <ConnectedRouter history={history}>
            <ScrollToTop>
              <Routes />
            </ScrollToTop>
          </ConnectedRouter>
        </ThemeProvider>
      </Provider>
    </AnalyticsProvider>
  );
}
